<template lang="pug">
  v-container.px-10(fluid)
    v-progress-linear(
      :active="loading",
      indeterminate,
      color="primary",
      absolute,
      top
    )
    v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
      v-col.py-0.text-right
        v-btn(color="white", @click="save()", :disabled="loading") {{ $t('Common.save') }}

    v-row(v-if="!loading")
      v-col.py-0
        v-card.elevation-24.mb-5
          app-full-entity(:entity="entity", :instance="instance")
            template(v-slot:Process="props")
              v-form.pa-5
                v-row(justify-end)
                  v-col
                    v-text-field(
                      :label="$t('Process.name')",
                      v-model="instance.name",
                      :error-messages="errors['process.name']",
                    )
                  v-col
                    v-select(
                      :label="$t('Process.entity')",
                      v-model="instance.entity",
                      :items="$store.state.schema.all.filter(s => entitiesForProcess.includes(s.name))",
                      item-text="name",
                      item-value="name",
                      @input="setEntityStore($event)",
                      :error-messages="errors['process.entity']",
                      :disabled="uid != null"
                     )
                v-row
                  v-col(cols="3")
                    v-text-field(
                      :value="instance.externalId",
                      disabled,
                      :label="$t('Process.externalId')",
                    )
                  v-col(cols="3")
                    v-text-field(
                      :label="$t('Process.userFullName')",
                      :value="(instance.user || {}).fullName"
                      :error-messages="errors['process.user']",
                      :error="!!errors['process.user']",
                      disabled,
                    )
                  v-col(cols="3")
                    app-datetime-picker(
                      :value="instance.createdAt",
                      disabled,
                      :label="$t('Process.createdAt')",
                    )
                  v-col(cols="3")
                    app-datetime-picker(
                      :value="instance.modifiedAt",
                      disabled,
                      :label="$t('Process.modifiedAt')",
                    )
              template(v-for="section in (props.sections || []).filter(x => x.section === entity.name || x.section === entity.tabLabel)")
                app-entity-relation(:path="section.name", :parent="entity", :parent-instance="instance", :relation="section", :entity="$findEntity(section.type)")
</template>

<script>
import axios from 'axios'
import EntityMixin from '@/mixins'
import { removeFirstCriteriaLogicalOperator } from '@@/helpers'

export default {
  mixins: [EntityMixin],
  name: 'process-add',
  data: () => ({
    loading: true,
    entitiesForProcess: ['Order', 'OrderLine', 'Shipment', 'Quote'],
    errors: {},
  }),
  computed: {
    entityName () {
      return 'Process'
    },
    entity () {
      return this.$searchEntity(this.entityName, 'name')
    },
    uid () {
      return this.$route.params.item
    },
  },
  methods: {
    async setEntityStore (rawValue) {
      this.$store.commit('SET_CRITERIA_ENTITY_NAME', this.instance.entity)
    },
    /* TODO: docs */
    async save () {
      // this.loading = true
      try {
        removeFirstCriteriaLogicalOperator(this.instance.criterias);
        this.instance = (await axios.post("entity/graph", this.instance)).data;
        this.$router.push({
          name: 'entities.index',
          params: { entity: this.entity.name, _Entity: this.entityName }
        })
      } catch (error) {
        this.errors = error.response.data.errors
      }
      // this.loading = false
    },
    /**
    Get Business Scope according to the businessScopeId given
    */
    async getBusinessScope(businessScopeId){
      if(businessScopeId == null) return null;
      let bs = (await axios.get('BusinessScope?where[]=id=' + businessScopeId)).data.data;
      return bs[0];
    },

    /* TODO: docs */
    async load () {
      if (this.uid) {
        try {
          this.instance.uid = this.uid
          const endpoint = this.$fetchLoad(`${this.entity.name}/${this.uid}`, true, 'User', 'Criterias')
          this.instance = {...this.instance, ...(await axios.get(endpoint, {
            _Entity: this.entityName,
            uid: this.uid
          })).data}
          this.instance._Entity = this.entityName
          this.instance.entityState = ENV.ENTITY.STATE.MODIFIED
          this.setEntityStore(this.instance.entity)
        } catch (error) {
          console.error(error)
        }
      } else
        this.$store.commit('SET_INSTANCE', {fields:[]})
      this.loading = false
    }
  },
  async created () {
    const lsbusinessScopeId = window.localStorage.getItem("BusinessScopeId");
    const lsbusinessScope = await this.getBusinessScope(lsbusinessScopeId);
    this.$store.commit('SET_INSTANCE', { entityState: 4,
                                        _Entity: this.entity.name,
                                        user: this.$store.state.user.user,
                                        businessScopeId: lsbusinessScopeId,
                                        businessScope: lsbusinessScope
                                        })
    await this.load()
  }
}
</script>
